// extracted by mini-css-extract-plugin
export var deliveryRow = "_qb-a";
export var fixedHeight = "_qb-4";
export var freightLogo = "_qb-9";
export var fullWidth = "_qb-3";
export var priceColumn = "_qb-5";
export var radioSelected = "_qb-7";
export var radioUnselected = "_qb-6";
export var selectedOption = "_qb-2";
export var selectedOptionContainer = "_qb-1";
export var selection = "_qb-0";
export var tallSkeletonText = "_qb-8";